import Toast from 'react-native-root-toast';

export type ErpToastType = 'success' | 'error' | 'info';

export function showErpToast(message: string, type: ErpToastType = 'info') {
  Toast.show(message, {
    position: Toast.positions.CENTER,
    duration: type === 'error' ? 3000 : 2000,
    shadow: true,
    animation: true,
    hideOnPress: true,
  });
}
